import PageHeader from '../PageHeader'
import Image from '../../images/header-about.png'

const HeaderAbout = () => {
  return (
    <>
        <PageHeader pageName="about" imageUrl={Image}>
            <h4 className="image-text">introductory text</h4>
            <h1 className="image-text">main title/text for the page header</h1>
            <p className="image-text">
                Lorem ipsum dolor, sit amet consectetur adipisicing elit. Accusantium impedit aut consectetur architecto asperiores assumenda?
            </p>
            <small className="image-text">Photography: <a className="image-text" href="https://stablediffusionweb.com/">stable-diffusion images</a></small>
        </PageHeader>
    </>
  )
}

export default HeaderAbout